import React, { useState, useEffect } from 'react';
import { obtenerPreciosPlanes } from '../../services/planesServicio';

var WA = '+56920039433';

var PLANES_BASE = [
    {
        key: 'MENU_QR',
        nombre: 'Komity Pedidos Web',
        icono: '📱',
        desc: 'Catálogo digital y pedidos online, sin POS ni caja',
        popular: false,
        features: [
            { label: 'Catálogo QR', ok: true },
            { label: 'Pedidos online', ok: true },
            { label: 'Panel de pedidos', ok: true },
            { label: 'Retiro y Despacho', ok: true },
            { label: 'Punto de Venta (POS)', ok: false },
            { label: 'Gestión de mesas', ok: false },
        ],
        waMensaje: function(precio) {
            return 'Hola! Quiero cambiar al plan Komity Pedidos Web ($' + precio.toLocaleString('es-CL') + '/mes).';
        },
    },
    {
        key: 'POS',
        nombre: 'Komity POS Take Away',
        icono: '🏪',
        desc: 'Venta en local, para llevar, sin mesas',
        popular: false,
        features: [
            { label: 'Punto de Venta', ok: true },
            { label: 'Caja', ok: true },
            { label: 'Impresión de comandas', ok: true },
            { label: 'Historial de ventas', ok: true },
            { label: 'Menú QR', ok: true },
            { label: 'Pedidos online', ok: false, addon: true },
            { label: 'Gestión de mesas', ok: false },
        ],
        waMensaje: function(precio) {
            return 'Hola! Quiero cambiar al plan Komity POS Take Away ($' + precio.toLocaleString('es-CL') + '/mes).';
        },
    },
    {
        key: 'RESTAURANTE',
        nombre: 'Plan Restaurante',
        icono: '🍽️',
        desc: 'POS y gestión de mesas. Menú QR incluido gratis',
        popular: true,
        features: [
            { label: 'Menú QR', ok: true },
            { label: 'Punto de Venta y Caja', ok: true },
            { label: 'Impresión de comandas', ok: true },
            { label: 'Gestión de mesas', ok: true },
            { label: 'Historial de ventas', ok: true },
            { label: 'Pedidos online', ok: false, addon: true },
        ],
        waMensaje: function(precio) {
            return 'Hola! Quiero cambiar al Plan Restaurante ($' + precio.toLocaleString('es-CL') + '/mes).';
        },
    },
];

export default function ModalPlanes({ abierto, onCerrar, planActual }) {
    var [precios, setPrecios] = useState({ MENU_QR: 14990, POS: 19990, RESTAURANTE: 24990, PEDIDOS_WEB_ADDON: 9990 });
    var [cargando, setCargando] = useState(false);

    useEffect(function() {
        if (!abierto) return;
        setCargando(true);
        obtenerPreciosPlanes().then(function(p) {
            setPrecios(p);
            setCargando(false);
        });
    }, [abierto]);

    if (!abierto) return null;

    function handleSolicitar(plan) {
        var precio = precios[plan.key] || 0;
        var url = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(plan.waMensaje(precio));
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    return (
        <div
            style={{
                position: 'fixed', inset: 0, zIndex: 99999,
                backgroundColor: 'rgba(0,0,0,0.6)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backdropFilter: 'blur(4px)',
                padding: '16px',
                animation: 'fadeIn .15s ease',
            }}
            onClick={function(e) { if (e.target === e.currentTarget) onCerrar(); }}
        >
            <div style={{
                background: '#fff',
                borderRadius: '20px',
                width: '100%',
                maxWidth: '860px',
                maxHeight: '90vh',
                overflowY: 'auto',
                boxShadow: '0 24px 60px rgba(0,0,0,0.22)',
            }}>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
                    padding: '24px 28px 20px',
                    borderRadius: '20px 20px 0 0',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                    <div>
                        <div style={{ color: '#fff', fontWeight: 700, fontSize: '18px' }}>
                            Planes disponibles
                        </div>
                        <div style={{ color: '#94a3b8', fontSize: '13px', marginTop: '3px' }}>
                            Compara y solicita el cambio de plan
                        </div>
                    </div>
                    <button
                        onClick={onCerrar}
                        style={{
                            background: 'rgba(255,255,255,0.08)', border: 'none', color: '#94a3b8',
                            width: '32px', height: '32px', borderRadius: '8px', cursor: 'pointer',
                            fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                    >
                        <i className="bi bi-x" />
                    </button>
                </div>

                {/* Cards */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                    gap: '20px',
                    padding: '24px',
                }}>
                    {PLANES_BASE.map(function(plan) {
                        var esActual = plan.key === planActual;
                        var precio = precios[plan.key] || 0;
                        return (
                            <div
                                key={plan.key}
                                style={{
                                    border: esActual
                                        ? '2px solid #10b981'
                                        : plan.popular ? '2px solid #f26522' : '1.5px solid #e2e8f0',
                                    borderRadius: '16px',
                                    padding: '22px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    position: 'relative',
                                    background: esActual ? '#f0fdf4' : '#fff',
                                }}
                            >
                                {esActual && (
                                    <div style={{
                                        position: 'absolute', top: '-12px', left: '16px',
                                        background: '#10b981', color: '#fff',
                                        fontSize: '11px', fontWeight: 700,
                                        padding: '3px 12px', borderRadius: '20px',
                                    }}>
                                        Tu plan actual
                                    </div>
                                )}
                                {plan.popular && !esActual && (
                                    <div style={{
                                        position: 'absolute', top: '-12px', left: '16px',
                                        background: '#f26522', color: '#fff',
                                        fontSize: '11px', fontWeight: 700,
                                        padding: '3px 12px', borderRadius: '20px',
                                    }}>
                                        Más elegido
                                    </div>
                                )}

                                <div style={{ fontSize: '28px', marginBottom: '8px' }}>{plan.icono}</div>
                                <div style={{ fontSize: '15px', fontWeight: 700, color: '#1e293b' }}>{plan.nombre}</div>
                                <div style={{ fontSize: '12px', color: '#64748b', marginTop: '3px', marginBottom: '14px' }}>{plan.desc}</div>

                                <div style={{ marginBottom: '16px' }}>
                                    {cargando ? (
                                        <div style={{ height: '34px', background: '#f1f5f9', borderRadius: '8px', width: '120px' }} />
                                    ) : (
                                        <>
                                            <span style={{ fontSize: '26px', fontWeight: 800, color: '#1e293b' }}>
                                                ${precio.toLocaleString('es-CL')}
                                            </span>
                                            <span style={{ fontSize: '13px', color: '#94a3b8' }}> /mes + IVA</span>
                                        </>
                                    )}
                                </div>

                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '7px', marginBottom: '20px' }}>
                                    {plan.features.map(function(f) {
                                        return (
                                            <div key={f.label} style={{
                                                display: 'flex', alignItems: 'center', gap: '8px',
                                                fontSize: '13px',
                                                color: f.ok ? '#1e293b' : (f.addon ? '#94a3b8' : '#cbd5e1'),
                                            }}>
                                                <i
                                                    className={f.ok ? 'bi bi-check-circle-fill' : (f.addon ? 'bi bi-plus-circle' : 'bi bi-x-circle')}
                                                    style={{ color: f.ok ? '#10b981' : (f.addon ? '#f26522' : '#e2e8f0'), fontSize: '14px', flexShrink: 0 }}
                                                />
                                                {f.label}
                                                {f.addon && !cargando && (
                                                    <span style={{ fontSize: '11px', color: '#f26522', fontWeight: 600 }}>
                                                        (add-on +${(precios.PEDIDOS_WEB_ADDON || 0).toLocaleString('es-CL')})
                                                    </span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                {esActual ? (
                                    <div style={{
                                        textAlign: 'center', padding: '10px',
                                        background: '#f0fdf4', borderRadius: '10px',
                                        fontSize: '13px', fontWeight: 600, color: '#10b981',
                                        border: '1.5px solid #a7f3d0',
                                    }}>
                                        <i className="bi bi-check2" /> Plan activo
                                    </div>
                                ) : (
                                    <button
                                        onClick={function() { handleSolicitar(plan); }}
                                        style={{
                                            width: '100%', padding: '11px',
                                            background: '#f26522', border: 'none', borderRadius: '10px',
                                            color: '#fff', fontWeight: 700, fontSize: '13px',
                                            cursor: 'pointer', display: 'flex',
                                            alignItems: 'center', justifyContent: 'center', gap: '6px',
                                        }}
                                        onMouseOver={function(e) { e.currentTarget.style.background = '#d9531a'; }}
                                        onMouseOut={function(e) { e.currentTarget.style.background = '#f26522'; }}
                                    >
                                        <i className="bi bi-whatsapp" /> Solicitar cambio
                                    </button>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div style={{ padding: '0 24px 20px', textAlign: 'center', fontSize: '12px', color: '#94a3b8' }}>
                    Para cambiar de plan, uno de nuestros asesores te contactará y coordinará el cambio.
                </div>
            </div>

            <style>{'@keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }'}</style>
        </div>
    );
}
